<ion-item-sliding #itemSliding [disabled]="actions.length < 1">
  <ion-item
    mode="ios"
    color="getm-neutral-white"
    lines="full"
    detail="false"
    class="swipe-actions__item"
  >
    <ng-content></ng-content>
  </ion-item>

  <ion-item-options side="end" color="getm-background-light-blue">
    <ion-item-option
      *ngIf="actions.includes('edit')"
      color="getm-background-light-blue"
      (click)="onEditClick()"
    >
      <ion-icon
        slot="icon-only"
        name="getm-edit-outline"
        color="getm-primary-default"
      ></ion-icon>
    </ion-item-option>
    <ion-item-option
      *ngIf="actions.includes('delete')"
      color="getm-background-light-blue"
      (click)="onDeleteClick()"
    >
      <ion-icon
        slot="icon-only"
        name="getm-trash-outline"
        color="getm-primary-default"
        class="swipe-actions__icon--trash"
      ></ion-icon>
    </ion-item-option>
  </ion-item-options>
</ion-item-sliding>
